/**
 * Servicio para gestión de estampados
 */
import api from "./api";
import { Estampado } from "@/components/personalizable/types";

export interface EstampadosResponse {
  success: boolean;
  estampados: Estampado[];
  count: number;
  categoria?: string;
}

export interface CreateEstampadoResponse {
  success: boolean;
  estampado: Estampado;
  message: string;
}

export const estampadosService = {
  /**
   * Obtener todos los estampados activos
   */
  async getEstampados(): Promise<Estampado[]> {
    const response = await api.get<EstampadosResponse>('/estampados');
    return response.data.estampados;
  },

  /**
   * Obtener estampados por categoría
   */
  async getEstampadosPorCategoria(categoria: string): Promise<Estampado[]> {
    const endpoint = categoria === 'todos'
      ? '/estampados'
      : `/estampados?categoria=${categoria}`;

    const response = await api.get<EstampadosResponse>(endpoint);
    return response.data.estampados;
  },

  /**
   * ADMIN: Crear nuevo estampado
   */
  async crearEstampado(formData: FormData): Promise<Estampado> {
    const response = await api.post<CreateEstampadoResponse>('/estampados', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data.estampado;
  },

  /**
   * ADMIN: Actualizar estampado existente
   */
  async actualizarEstampado(id: string, data: Partial<Estampado>): Promise<Estampado> {
    const response = await api.put<CreateEstampadoResponse>(`/estampados/${id}`, data);
    return response.data.estampado;
  },

  /**
   * ADMIN: Eliminar estampado
   */
  async eliminarEstampado(id: string): Promise<void> {
    await api.delete(`/estampados/${id}`);
  }
};

export default estampadosService;
